import { SECRET_FIELD_PATHS, type AppSettings } from '../settings/types';
import { useBackendAuth } from './apiClient';

/** True when Stripe secret is in local settings or stored in Secret Manager (backend). */
export function isStripeConfigured(
  settings: AppSettings,
  isSecretConfigured: (path: string) => boolean
): boolean {
  if (settings.integrations.stripe.secretKey.trim()) {
    return true;
  }
  return useBackendAuth && isSecretConfigured(SECRET_FIELD_PATHS.stripeSecretKey);
}

export function isIntegrationSecretConfigured(
  isSecretConfigured: (path: string) => boolean,
  path: string,
  localValue: string
): boolean {
  return Boolean(localValue.trim()) || (useBackendAuth && isSecretConfigured(path));
}
